<template>
  <div class="errorPage">
    <div class="errors">
      <div class="error__title">404</div>
      <div class="error__subtitle">Странно...</div>
      <div class="error__description">
        Такое ощущение что программист уснул <br>
        Нужно перейти в
      </div>
      <router-link to='/support'>
        <v-btn color="primary">Тех. поддержка</v-btn>
      </router-link>
      <!-- <button class="error__button error__button--active">LOGIN</button> -->
      <!-- <button class="error__button">CONTACT</button> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "error_page",
  data: () => ({}),
  mounted() {
    this.setTitle('404')
  },
};
</script>
<style lang='scss'>
.errorPage {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.errors {
  display: grid;
  position: relative;
  top: 200px;
  transform: translateY(-60%);
  font-family: "Righteous", cursive;
  background-color: transparent;
  color: #363e49;
}

.error__title {
  font-size: 10em;
}

.error__subtitle {
  font-size: 2em;
}

.error__description {
  opacity: 0.5;
}
</style>